// src/components/UploadFlow.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React9, { useEffect as useEffect8, useState as useState6 } from "react";
import { WranglerDataProvider } from "@vp/wrangler-data-source";
// src/analytics/Analytics.ts
import { getTracking } from "@vp/tracking";
var Analytics = function Analytics(analyticsPageData, mpvId) {
    "use strict";
    var _this = this;
    _class_call_check(this, Analytics);
    this.getPageSection = function() {
        return _this._analyticsPageData.pageSection;
    };
    this.getPageStage = function() {
        return _this._analyticsPageData.pageStage;
    };
    this.getPageName = function() {
        return _this._analyticsPageData.pageName;
    };
    this.getProductId = function() {
        return _this._product_id;
    };
    this.getCoreProductId = function() {
        return _this._analyticsPageData.coreProductId;
    };
    this.trackDialogDisplayed = function(initialSelections) {
        var tracking = getTracking();
        if (!tracking) {
            console.error("tracking not initialized");
            return;
        }
        tracking.track("Design PopUp Displayed", _object_spread_props(_object_spread({
            category: "Design - Upload",
            label: "Options Display",
            product_id: _this._product_id
        }, _this._analyticsPageData), {
            initialSelection: {
                selections: initialSelections
            }
        }), {});
    };
    this._analyticsPageData = analyticsPageData;
    this._product_id = mpvId;
};
// src/analytics/AnalyticsProvider.tsx
import React, { createContext, useContext } from "react";
var AnalyticsContext = createContext(null);
function useAnalytics() {
    var analyticsContext = useContext(AnalyticsContext);
    if (!analyticsContext) {
        throw new Error("Cannot use the useAnalytics hook without a Analytics manager");
    }
    return analyticsContext;
}
var AnalyticsProvider = function(param) {
    var children = param.children, analytics = param.analytics;
    var Provider = AnalyticsContext.Provider;
    return /* @__PURE__ */ React.createElement(Provider, {
        value: analytics
    }, children);
};
// src/utils/useSingleInitialize.ts
import { useRef } from "react";
function useSingleInitialize(initializer) {
    var ref = useRef(null);
    if (ref.current !== null) {
        return ref.current;
    }
    ref.current = initializer();
    return ref.current;
}
// src/components/UploadFlowComponent.tsx
import React7, { useState as useState5, useEffect as useEffect7, useMemo as useMemo4 } from "react";
import { Button as Button2, Spinner } from "@vp/swan";
// src/components/UploadDialog.tsx
import React5, { useContext as useContext4, useEffect as useEffect4, useMemo as useMemo3, useState as useState3 } from "react";
import { ModalDialog, ModalDialogBody, Typography, ModalDialogContent, ModalDialogCloseButton, ModalDialogHeader, ModalDialogTitle, useScreenClass, ModalDialogNav, ModalDialogFooter } from "@vp/swan";
// src/infrastructure/locales/da-dk.json
var da_dk_default = {
    upload: "Upload",
    select: "V\xE6lg",
    loading: "Indl\xE6ser ...",
    close: "Luk",
    quantity: "Antal",
    selectNote: "V\xE6lg alle p\xE5kr\xE6vede muligheder.",
    "upload-dialog-cta": "N\xE6ste"
};
// src/infrastructure/locales/de-de.json
var de_de_default = {
    upload: "Hochladen",
    select: "Ausw\xE4hlen",
    loading: "Wird geladen\u2026",
    close: "Schlie\xDFen",
    quantity: "Menge",
    selectNote: "Bitte w\xE4hlen Sie alle erforderlichen Optionen aus.",
    "upload-dialog-cta": "Weiter"
};
// src/infrastructure/locales/en-gb.json
var en_gb_default = {
    upload: "Upload",
    select: "Select",
    loading: "Loading...",
    close: "Close",
    quantity: "Quantity",
    selectNote: "Please select all required options.",
    "upload-dialog-cta": "Next"
};
// src/infrastructure/locales/es-es.json
var es_es_default = {
    upload: "Subir",
    select: "Seleccionar",
    loading: "Cargando...",
    close: "Cerrar",
    quantity: "Cantidad",
    selectNote: "Selecciona todas las opciones obligatorias.",
    "upload-dialog-cta": "Siguiente"
};
// src/infrastructure/locales/es-us.json
var es_us_default = {
    upload: "Subir",
    select: "Seleccionar",
    loading: "Cargando...",
    close: "Cerrar",
    quantity: "Cantidad",
    selectNote: "Seleccione todas las opciones requeridas.",
    "upload-dialog-cta": "Siguiente"
};
// src/infrastructure/locales/en-us.json
var en_us_default = {
    upload: "Upload",
    select: "Select",
    loading: "Loading...",
    close: "Close",
    quantity: "Quantity",
    selectNote: "Please select all required options.",
    "upload-dialog-cta": "Next"
};
// src/infrastructure/locales/fi-fi.json
var fi_fi_default = {
    upload: "Lataa palvelimeen",
    select: "Valitse",
    loading: "Ladataan...",
    close: "Sulje",
    quantity: "M\xE4\xE4r\xE4",
    selectNote: "Valitse kaikki tarvittavat vaihtoehdot.",
    "upload-dialog-cta": "Seuraava"
};
// src/infrastructure/locales/fr-ca.json
var fr_ca_default = {
    upload: "T\xE9l\xE9verser",
    select: "S\xE9lectionner",
    loading: "Chargement en cours...",
    close: "Fermer",
    quantity: "Quantit\xE9",
    selectNote: "Veuillez s\xE9lectionner toutes les options obligatoires.",
    "upload-dialog-cta": "Suivant"
};
// src/infrastructure/locales/fr-fr.json
var fr_fr_default = {
    upload: "T\xE9l\xE9charger",
    select: "S\xE9lectionner",
    loading: "En cours de chargement...",
    close: "Fermer",
    quantity: "Quantit\xE9",
    selectNote: "Veuillez s\xE9lectionner toutes les options requises.",
    "upload-dialog-cta": "Suivant"
};
// src/infrastructure/locales/it-it.json
var it_it_default = {
    upload: "Carica",
    select: "Seleziona",
    loading: "Caricamento in corso...",
    close: "Chiudi",
    quantity: "Quantit\xE0",
    selectNote: "Scegli tutte le opzioni richieste.",
    "upload-dialog-cta": "Avanti"
};
// src/infrastructure/locales/nb-no.json
var nb_no_default = {
    upload: "Last opp",
    select: "Velg",
    loading: "Laster\xA0...",
    close: "Lukk",
    quantity: "Antall",
    selectNote: "Velg alle p\xE5krevde alternativer.",
    "upload-dialog-cta": "Neste"
};
// src/infrastructure/locales/nl-nl.json
var nl_nl_default = {
    upload: "Uploaden",
    select: "Selecteer",
    loading: "Bezig met laden...",
    close: "Sluiten",
    quantity: "Hoeveelheid",
    selectNote: "Selecteer alle verplichte opties.",
    "upload-dialog-cta": "Volgende"
};
// src/infrastructure/locales/pt-pt.json
var pt_pt_default = {
    upload: "Carregar",
    select: "Selecionar",
    loading: "A carregar...",
    close: "Fechar",
    quantity: "Quantidade",
    selectNote: "Selecione todas as op\xE7\xF5es obrigat\xF3rias.",
    "upload-dialog-cta": "Seguinte"
};
// src/infrastructure/locales/sv-se.json
var sv_se_default = {
    upload: "Ladda upp",
    select: "V\xE4lj",
    loading: "L\xE4ser in\xA0...",
    close: "St\xE4ng",
    quantity: "Antal",
    selectNote: "V\xE4lj alla obligatoriska alternativ.",
    "upload-dialog-cta": "N\xE4sta"
};
// src/infrastructure/locales/index.ts
var locales = {
    "da-dk": da_dk_default,
    "de-at": de_de_default,
    "de-ch": de_de_default,
    "de-de": de_de_default,
    "en-au": en_gb_default,
    "en-ca": en_us_default,
    "en-gb": en_gb_default,
    "en-ie": en_gb_default,
    "en-in": en_gb_default,
    "en-nz": en_gb_default,
    "en-sg": en_gb_default,
    "en-us": en_us_default,
    "es-es": es_es_default,
    "es-us": es_us_default,
    "fi-fi": fi_fi_default,
    "fr-be": fr_fr_default,
    "fr-ca": fr_ca_default,
    "fr-ch": fr_fr_default,
    "fr-fr": fr_fr_default,
    "it-ch": it_it_default,
    "it-it": it_it_default,
    "nb-no": nb_no_default,
    "nl-be": nl_nl_default,
    "nl-nl": nl_nl_default,
    "pt-pt": pt_pt_default,
    "sv-se": sv_se_default
};
var locales_default = locales;
// src/infrastructure/localizations.ts
var get = function(key, locale) {
    var localization = locales_default[locale.toLowerCase()];
    if (!localization) {
        return "";
    }
    var _localization_key;
    return (_localization_key = localization[key]) !== null && _localization_key !== void 0 ? _localization_key : "";
};
var getUnsafe = function(key, locale) {
    var localization = locales_default[locale.toLowerCase()];
    if (!localization) {
        return "";
    }
    var _localization_key;
    return (_localization_key = localization[key]) !== null && _localization_key !== void 0 ? _localization_key : "";
};
var localizations_default = {
    get: get,
    getUnsafe: getUnsafe
};
// src/components/UploadDialog.tsx
import { ContextAwareConfigurator, ProductOptions, FooterPrice } from "@vp/simple-configurator-with-no-preview";
import { ManagedWranglerSelectionsProvider, WranglerDataContext, useManagedWranglerSelectionsContext } from "@vp/wrangler-data-source";
// src/components/UploadDialogCta.tsx
import { PRODUCT_OPTIONS_SELECTED_EVENT_NAME, trackProductOptionsSelected } from "@vp/product-options-tracking";
import { AlertBox, AlertBoxDismissButton, Button, Link } from "@vp/swan";
import React3, { useContext as useContext2 } from "react";
// src/infrastructure/vistaprintPaths.ts
var vistaprintPaths = {
    "en-ie": "https://www.vistaprint.ie",
    "pt-pt": "https://www.vistaprint.pt",
    "es-es": "https://www.vistaprint.es",
    "en-in": "https://www.vistaprint.in",
    "de-at": "https://www.vistaprint.at",
    "fr-be": "https://www.vistaprint.be",
    "nl-be": "https://www.vistaprint.be",
    "fr-ca": "https://www.vistaprint.ca",
    "en-ca": "https://www.vistaprint.ca",
    "de-ch": "https://www.vistaprint.ch",
    "fr-ch": "https://www.vistaprint.ch",
    "it-ch": "https://www.vistaprint.ch",
    "en-nz": "https://www.vistaprint.co.nz",
    "en-gb": "https://www.vistaprint.co.uk",
    "en-us": "https://www.vistaprint.com",
    "es-us": "https://www.vistaprint.com",
    "en-au": "https://www.vistaprint.com.au",
    "de-de": "https://www.vistaprint.de",
    "da-dk": "https://www.vistaprint.dk",
    "fi-fi": "https://www.vistaprint.fi",
    "fr-fr": "https://www.vistaprint.fr",
    "it-it": "https://www.vistaprint.it",
    "nl-nl": "https://www.vistaprint.nl",
    "nb-no": "https://www.vistaprint.no",
    "sv-se": "https://www.vistaprint.se",
    "en-sg": "https://www.vistaprint.sg"
};
// src/utils/generic.ts
function applyUrlAdjustments(nextUrl, locale, studioDocumentUrl, useFullPath) {
    var nextStepUrl = nextUrl;
    if (nextStepUrl && studioDocumentUrl) {
        nextStepUrl = getStudioUrlWithDocumentUrl(nextStepUrl, studioDocumentUrl);
    }
    if (nextStepUrl && useFullPath) {
        nextStepUrl = "".concat(vistaprintPaths[locale.toLowerCase()]).concat(nextStepUrl);
    }
    return nextStepUrl || "";
}
var getStudioUrlWithDocumentUrl = function(studioUrl, studioDocumentUrl) {
    return "".concat(studioUrl, "&documentUrl=").concat(encodeURIComponent(studioDocumentUrl));
};
function navigate(e, url) {
    e.preventDefault();
    if (typeof window !== "undefined" && url) {
        window.location.href = url;
    }
}
// src/providers/LoggingProvider.tsx
import React2, { useMemo } from "react";
// src/providers/logging/FormatMessage.ts
var formatMessage = function(message, context) {
    return {
        message: message,
        context: sanitizeContext(context, /* @__PURE__ */ new Set())
    };
};
var SENSITIVE_STRINGS = [
    "bearer",
    "eyj0exblijoiand0"
];
var SENSITIVE_KEYS = [
    "authorization",
    "client_secret"
];
var sanitizeContext = function(context, visited) {
    if (visited.has(context)) {
        return "[Circular]";
    }
    if (context === null || (typeof context === "undefined" ? "undefined" : _type_of(context)) !== "object") {
        if (typeof context === "string") {
            return sanitizeString(context);
        }
        return context;
    }
    visited.add(context);
    if (Array.isArray(context)) {
        return context.map(function(d) {
            return sanitizeContext(d, visited);
        });
    } else {
        var keys = _instanceof(context, Error) ? Object.getOwnPropertyNames(context) : Object.keys(context);
        var sanitizedDetails = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (context[key] !== void 0) {
                    sanitizedDetails[key] = SENSITIVE_KEYS.includes(key.toLowerCase()) ? "[REDACTED]" : sanitizeContext(context[key], visited);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return sanitizedDetails;
    }
};
var sanitizeString = function(str) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = SENSITIVE_STRINGS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var test = _step.value;
            var sensitiveStart = str.toLowerCase().indexOf(test);
            if (sensitiveStart > -1) {
                return str.slice(0, sensitiveStart + test.length) + " [REDACTED]";
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return str;
};
// src/providers/logging/ConsoleLogger.ts
var ConsoleLogger = /*#__PURE__*/ function() {
    "use strict";
    function ConsoleLogger() {
        var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, ConsoleLogger);
        this.context = context;
    }
    _create_class(ConsoleLogger, [
        {
            key: "debug",
            value: function debug(message) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var fullContext = _object_spread({}, this.context, context);
                var formatted = formatMessage(message, fullContext);
                console.debug(formatted.message, formatted.context);
            }
        },
        {
            key: "info",
            value: function info(message) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var fullContext = _object_spread({}, this.context, context);
                var formatted = formatMessage(message, fullContext);
                console.info(formatted.message, formatted.context);
            }
        },
        {
            key: "warn",
            value: function warn(message) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var fullContext = _object_spread({}, this.context, context);
                var formatted = formatMessage(message, fullContext);
                console.warn(formatted.message, formatted.context);
            }
        },
        {
            key: "error",
            value: function error(message) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var fullContext = _object_spread({}, this.context, context);
                var formatted = formatMessage(message, fullContext);
                console.error(formatted.message, formatted.context);
            }
        }
    ]);
    return ConsoleLogger;
}();
// src/providers/logging/NewRelicProxyLogger.ts
var NEW_RELIC_PROXY_HOST = "https://physical-products-newrelic-logger.large-assortment.vpsvc.com";
var NewRelicProxyLogger = /*#__PURE__*/ function() {
    "use strict";
    function NewRelicProxyLogger(newRelicApplicationId, requestor2, authToken) {
        var context = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        _class_call_check(this, NewRelicProxyLogger);
        this.authToken = authToken;
        this.context = _object_spread_props(_object_spread({}, context), {
            requestor: requestor2
        });
        this.url = NEW_RELIC_PROXY_HOST + "/v1/log/".concat(newRelicApplicationId, "?requestor=").concat(encodeURIComponent(requestor2));
    }
    _create_class(NewRelicProxyLogger, [
        {
            key: "debug",
            value: function debug(message) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.logMessage("DEBUG", message, options === null || options === void 0 ? void 0 : options.context);
            }
        },
        {
            key: "info",
            value: function info(message, options) {
                this.logMessage("INFO", message, options === null || options === void 0 ? void 0 : options.context);
            }
        },
        {
            key: "warn",
            value: function warn(message, options) {
                this.logMessage("WARN", message, options === null || options === void 0 ? void 0 : options.context);
            }
        },
        {
            key: "error",
            value: function error(message, options) {
                this.logMessage("ERROR", message, options === null || options === void 0 ? void 0 : options.context);
            }
        },
        {
            key: "logMessage",
            value: function logMessage(level, message) {
                var additionalContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var context = _object_spread_props(_object_spread({}, this.context, additionalContext), {
                    timestamp: /* @__PURE__ */ new Date().toISOString()
                });
                var formatted = formatMessage(message, context);
                var payload = {
                    level: level,
                    message: formatted.message,
                    context: formatted.context
                };
                var promise = fetch(this.url, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + this.authToken,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                promise.catch(function(error) {
                    return console.error(error);
                });
            }
        }
    ]);
    return NewRelicProxyLogger;
}();
// src/providers/logging/index.ts
var LOGGING_REQUESTOR = "upload-flow-component";
var NEW_RELIC_APPLICATION_ID = 1120350844;
// src/providers/LoggingProvider.tsx
var LoggingContext = React2.createContext(new ConsoleLogger({
    from: "DEFAULT CONTEXT"
}));
function LoggingProvider(param) {
    var newRelicApplicationId = param.newRelicApplicationId, requestor2 = param.requestor, context = param.context, authToken = param.authToken, children = param.children;
    var logger = useMemo(function() {
        return newRelicApplicationId && authToken ? new NewRelicProxyLogger(newRelicApplicationId, requestor2, authToken, context) : new ConsoleLogger(context);
    }, [
        newRelicApplicationId,
        requestor2,
        authToken,
        context
    ]);
    return /* @__PURE__ */ React2.createElement(LoggingContext.Provider, {
        value: logger
    }, children);
}
// src/components/UploadDialogCta.tsx
import { useWranglerDataContext, WranglerDataSource } from "@vp/wrangler-data-source";
// src/hooks/useSiteflowNextStep.ts
import { useEffect, useState } from "react";
// src/clients/SiteflowClient.ts
import qs from "qs";
// src/utils/abTest.ts
import { getAllExperiments, waitTillAvailable, getTestUserId as getABReaderTestUserId, initialize } from "@vp/ab-reader";
var mandatoryTestWhitelist = [
    "NA_Brochures_Studio3D"
];
var ABTests = /*#__PURE__*/ function() {
    "use strict";
    function ABTests() {
        _class_call_check(this, ABTests);
    }
    _create_class(ABTests, null, [
        {
            key: "getABTests",
            value: function getABTests() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.abExperiments !== null) {
                                    return [
                                        2,
                                        _this.abExperiments
                                    ];
                                }
                                return [
                                    4,
                                    _this.waitForInitializationOnce()
                                ];
                            case 1:
                                _state.sent();
                                _this.abExperiments = getAllExperiments();
                                return [
                                    2,
                                    _this.abExperiments
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVariation",
            value: function getVariation(experimentName) {
                var _this = this;
                return _async_to_generator(function() {
                    var _find, _this1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getABTests()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_this1 = _state.sent()) === null || _this1 === void 0 ? void 0 : (_find = _this1.find(function(e) {
                                        return e.experimentKey === experimentName;
                                    })) === null || _find === void 0 ? void 0 : _find.variationKey
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTestUserId",
            value: function getTestUserId() {
                var _this = this;
                return _async_to_generator(function() {
                    var _getABReaderTestUserId;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.waitForInitializationOnce()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    (_getABReaderTestUserId = getABReaderTestUserId()) !== null && _getABReaderTestUserId !== void 0 ? _getABReaderTestUserId : void 0
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getABTestString",
            value: function getABTestString() {
                var _this = this;
                return _async_to_generator(function() {
                    var experiments;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getABTests()
                                ];
                            case 1:
                                experiments = _state.sent();
                                if (experiments && experiments.length > 0) {
                                    return [
                                        2,
                                        experiments.filter(function(e) {
                                            return mandatoryTestWhitelist.some(function(key) {
                                                return key === e.experimentKey;
                                            });
                                        }).sort(function(a, b) {
                                            return a.experimentKey.localeCompare(b.experimentKey);
                                        }).map(function(e) {
                                            return "".concat(e.experimentKey, ":").concat(e.variationKey);
                                        }).join(",")
                                    ];
                                }
                                return [
                                    2,
                                    ""
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "waitForInitializationOnce",
            value: function waitForInitializationOnce() {
                if (this.availablePromise === null) {
                    initialize();
                    this.availablePromise = waitTillAvailable(1e3);
                }
                return this.availablePromise;
            }
        }
    ]);
    return ABTests;
}();
ABTests.availablePromise = null;
ABTests.abExperiments = null;
// src/clients/SiteflowClient.ts
var siteflowBaseUrl = "https://siteflow.merch.vpsvc.com";
var requestor = "UploadFlow";
var MAX_URL_LENGTH = 2048;
var fetchWithRetry = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(url, retries, delay) {
        var response, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    return [
                        2,
                        response
                    ];
                case 2:
                    error = _state.sent();
                    if (!(retries > 0)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        new Promise(function(res) {
                            return setTimeout(res, delay);
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        fetchWithRetry(url, retries - 1, delay * 2)
                    ];
                case 4:
                    throw error;
                case 5:
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, retries, delay) {
        return _ref.apply(this, arguments);
    };
}();
var getActionUrl = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(params) {
        var tenant, locale, productKey, version, flowAction, selections, selectedQuantity, logging, abString, testUserId, queryParams, queryString, baseUrl, url, response, data, error, message;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    tenant = params.tenant, locale = params.locale, productKey = params.productKey, version = params.version, flowAction = params.flowAction, selections = params.selections, selectedQuantity = params.selectedQuantity, logging = params.logging;
                    return [
                        4,
                        ABTests.getABTestString()
                    ];
                case 1:
                    abString = _state.sent();
                    return [
                        4,
                        ABTests.getTestUserId()
                    ];
                case 2:
                    testUserId = _state.sent();
                    queryParams = {
                        optionValues: selections,
                        quantity: selectedQuantity,
                        optimizelyEndUserId: testUserId,
                        siteContext: abString !== null && abString !== void 0 ? abString : "",
                        requestor: "".concat(requestor).concat(process.env.NODE_ENV === "development" ? "_development" : "")
                    };
                    queryString = qs.stringify(queryParams, {
                        arrayFormat: "comma"
                    });
                    baseUrl = "".concat(siteflowBaseUrl, "/v2/action/").concat(tenant, "/").concat(locale, "/").concat(flowAction, "/").concat(productKey, "/").concat(version, "?");
                    if (baseUrl.length + queryString.length > MAX_URL_LENGTH) {
                        logging.error("Unable to add site context to Siteflow, URL too long");
                        delete queryParams.siteContext;
                        queryString = qs.stringify(queryParams, {
                            arrayFormat: "comma"
                        });
                    }
                    url = "".concat(baseUrl).concat(queryString);
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetchWithRetry(url, 2, 1e3)
                    ];
                case 4:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    data = _state.sent();
                    if (data) {
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        void 0
                    ];
                case 6:
                    error = _state.sent();
                    message = "There was an error while getting action url from siteflow: ".concat(JSON.stringify(error, null, 2));
                    logging.error(message, {
                        error: _instanceof(error, Error) ? error : error,
                        context: {
                            url: url
                        }
                    });
                    throw error;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function getActionUrl(params) {
        return _ref.apply(this, arguments);
    };
}();
// src/hooks/useSiteflowNextStep.ts
var useSiteflowNextStep = function(tenant, locale, selections, productKey, version, flowAction, selectedQuantity, logging) {
    var _useState = _sliced_to_array(useState(void 0), 2), siteflowUrl = _useState[0], setSiteflowUrl = _useState[1];
    useEffect(function() {
        var mounted = true;
        var getSiteflowUrl = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var siteflowActionResponse;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getActionUrl({
                                    tenant: tenant,
                                    locale: locale,
                                    selections: selections,
                                    productKey: productKey,
                                    version: version,
                                    flowAction: flowAction,
                                    selectedQuantity: selectedQuantity,
                                    logging: logging
                                })
                            ];
                        case 1:
                            siteflowActionResponse = _state.sent();
                            if (mounted) {
                                setSiteflowUrl(siteflowActionResponse === null || siteflowActionResponse === void 0 ? void 0 : siteflowActionResponse.url);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function getSiteflowUrl() {
                return _ref.apply(this, arguments);
            };
        }();
        getSiteflowUrl();
        return function() {
            mounted = false;
        };
    }, [
        selections,
        selectedQuantity,
        tenant,
        locale,
        productKey,
        version,
        getActionUrl
    ]);
    return siteflowUrl;
};
// src/components/UploadDialogCta.tsx
var UploadDialogCta = function(props) {
    var _wranglerData_data_selections, _wranglerData_data, _finalPriceInfo_quantities_find, _finalPriceInfo_quantities_find1;
    var initialPrice = props.initialPrice, finalPriceInfo = props.finalPriceInfo, initialQuantity = props.initialQuantity, finalQuantity = props.finalQuantity, tenant = props.tenant, locale = props.locale, initialSelections = props.initialSelections, finalSelections = props.finalSelections, productKey = props.productKey, productVersion = props.productVersion, siteflowAction = props.siteflowAction, studioDocumentUrl = props.studioDocumentUrl, productName = props.productName, showError = props.showError, formValid = props.formValid, useFullPath = props.useFullPath, authToken = props.authToken, onSubmitButtonSuccess = props.onSubmitButtonSuccess, onSubmitButtonError = props.onSubmitButtonError, onToastClose = props.onToastClose;
    var logger = useContext2(LoggingContext);
    var wranglerData = useWranglerDataContext();
    var documentChanges = wranglerData === null || wranglerData === void 0 ? void 0 : (_wranglerData_data = wranglerData.data) === null || _wranglerData_data === void 0 ? void 0 : (_wranglerData_data_selections = _wranglerData_data.selections) === null || _wranglerData_data_selections === void 0 ? void 0 : _wranglerData_data_selections.document;
    var documentChangesPending = documentChanges === null || documentChanges === void 0 ? void 0 : documentChanges.changesPending;
    var analytics = useAnalytics();
    var mpvId = analytics === null || analytics === void 0 ? void 0 : analytics.getProductId();
    var pageSection = analytics === null || analytics === void 0 ? void 0 : analytics.getPageSection();
    var pageName = analytics === null || analytics === void 0 ? void 0 : analytics.getPageName();
    var pageStage = analytics === null || analytics === void 0 ? void 0 : analytics.getPageStage();
    var currentDiscountedPrice = finalPriceInfo === null || finalPriceInfo === void 0 ? void 0 : (_finalPriceInfo_quantities_find = finalPriceInfo.quantities.find(function(quantityPrice) {
        return quantityPrice.quantity === finalQuantity;
    })) === null || _finalPriceInfo_quantities_find === void 0 ? void 0 : _finalPriceInfo_quantities_find.discountPrice;
    var currentListPrice = finalPriceInfo === null || finalPriceInfo === void 0 ? void 0 : (_finalPriceInfo_quantities_find1 = finalPriceInfo.quantities.find(function(quantityPrice) {
        return quantityPrice.quantity === finalQuantity;
    })) === null || _finalPriceInfo_quantities_find1 === void 0 ? void 0 : _finalPriceInfo_quantities_find1.listPrice;
    var siteflowUrl = useSiteflowNextStep(tenant, locale, finalSelections, productKey, productVersion, siteflowAction, finalQuantity, logger);
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, showError && /* @__PURE__ */ React3.createElement(AlertBox, {
        mb: "4",
        skin: "error",
        id: "select-option-continue-note",
        "aria-live": "assertive",
        style: {
            width: "100%"
        }
    }, localizations_default.get("selectNote", locale), /* @__PURE__ */ React3.createElement(AlertBoxDismissButton, {
        accessibleText: localizations_default.get("close", locale),
        onClick: function() {
            onToastClose();
        }
    })), /* @__PURE__ */ React3.createElement(Button, {
        skin: "primary",
        width: "full-width",
        mt: "to-actions",
        onClick: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(e) {
                var initialDiscountedPrice, _initialPrice_breakdown, initialBreakdown, _finalPriceInfo_pricesBreakdownArray, currentBreakdown, productOptionsForTracking, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, optionKey, valueKey, update, initialOptionPrice, currentOptionPrice, _finalQuantity_toString, variant, docTrans, docUrl, _realizedDocumentUrl_self, _realizedDocumentUrl, url;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e.preventDefault();
                            if (!formValid) {
                                onSubmitButtonError({});
                                return [
                                    2
                                ];
                            }
                            onSubmitButtonSuccess({
                                finalSelections: finalSelections,
                                finalQuantity: finalQuantity
                            });
                            initialDiscountedPrice = initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.totalDiscountedPrice;
                            initialBreakdown = (_initialPrice_breakdown = initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.breakdown) !== null && _initialPrice_breakdown !== void 0 ? _initialPrice_breakdown : [];
                            currentBreakdown = (_finalPriceInfo_pricesBreakdownArray = finalPriceInfo === null || finalPriceInfo === void 0 ? void 0 : finalPriceInfo.pricesBreakdownArray) !== null && _finalPriceInfo_pricesBreakdownArray !== void 0 ? _finalPriceInfo_pricesBreakdownArray : [];
                            productOptionsForTracking = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = Object.entries(finalSelections || [])[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    _step_value = _sliced_to_array(_step.value, 2), optionKey = _step_value[0], valueKey = _step_value[1];
                                    update = "nochange";
                                    initialOptionPrice = getBreakdownOptionPrice(initialBreakdown, optionKey);
                                    currentOptionPrice = getBreakdownOptionPrice(currentBreakdown, optionKey);
                                    update = determineUpsellOrDownsell(initialOptionPrice, currentOptionPrice);
                                    productOptionsForTracking.push({
                                        key: optionKey,
                                        value: valueKey,
                                        isUpdated: valueKey !== initialSelections[optionKey],
                                        update: update,
                                        isVisible: !Object.keys(initialSelections).includes(optionKey)
                                    });
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            productOptionsForTracking.push({
                                key: "Quantity",
                                value: (_finalQuantity_toString = finalQuantity === null || finalQuantity === void 0 ? void 0 : finalQuantity.toString()) !== null && _finalQuantity_toString !== void 0 ? _finalQuantity_toString : "0",
                                isUpdated: finalQuantity !== initialQuantity,
                                update: getProductUpdateForQuantity(finalQuantity, initialQuantity),
                                isVisible: true
                            });
                            variant = productOptionsForTracking.map(function(option) {
                                return "".concat(option.key, ":").concat(option.value);
                            }).join("_");
                            docTrans = studioDocumentUrl ? documentChangesPending ? "true" : "false" : "na";
                            trackProductOptionsSelected({
                                category: "Upload Flow",
                                pageSection: pageSection,
                                pageStage: pageStage,
                                pageName: pageName,
                                label: PRODUCT_OPTIONS_SELECTED_EVENT_NAME,
                                product_id: mpvId,
                                name: productName,
                                core_product_id: productKey,
                                productOptions: productOptionsForTracking,
                                productUpdate: determineUpsellOrDownsell(initialDiscountedPrice, currentDiscountedPrice),
                                docTrans: docTrans,
                                price: currentDiscountedPrice !== null && currentDiscountedPrice !== void 0 ? currentDiscountedPrice : 0,
                                list_price: currentListPrice !== null && currentListPrice !== void 0 ? currentListPrice : 0,
                                sales_quantity: finalQuantity !== null && finalQuantity !== void 0 ? finalQuantity : 1,
                                variant: variant
                            });
                            docUrl = studioDocumentUrl;
                            if (!documentChangesPending) return [
                                3,
                                2
                            ];
                            if (!authToken) {
                                logger.error("No auth token available to realize document", {
                                    context: {
                                        documentChanges: documentChanges
                                    }
                                });
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                WranglerDataSource.realizeDocument(authToken, documentChanges)
                            ];
                        case 1:
                            _realizedDocumentUrl = _state.sent();
                            if (_realizedDocumentUrl === null || _realizedDocumentUrl === void 0 ? void 0 : (_realizedDocumentUrl_self = _realizedDocumentUrl.self) === null || _realizedDocumentUrl_self === void 0 ? void 0 : _realizedDocumentUrl_self.href) {
                                docUrl = _realizedDocumentUrl.self.href;
                            }
                            _state.label = 2;
                        case 2:
                            url = applyUrlAdjustments(siteflowUrl || "", locale, docUrl, useFullPath);
                            navigate(e, url);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(),
        render: function(renderProps) {
            return /* @__PURE__ */ React3.createElement(Link, _object_spread({
                to: siteflowUrl !== null && siteflowUrl !== void 0 ? siteflowUrl : ""
            }, renderProps), renderProps.children);
        }
    }, localizations_default.getUnsafe("upload-dialog-cta", locale)));
};
function getBreakdownOptionPrice(breakdown, optionKey) {
    var _breakdown_find;
    var _breakdown_find_listPrice;
    return (_breakdown_find_listPrice = (_breakdown_find = breakdown.find(function(breakdownOption) {
        return breakdownOption.attributeKey === optionKey;
    })) === null || _breakdown_find === void 0 ? void 0 : _breakdown_find.listPrice) !== null && _breakdown_find_listPrice !== void 0 ? _breakdown_find_listPrice : 0;
}
function getProductUpdateForQuantity(finalQuantity, initialQuantity) {
    if (finalQuantity > initialQuantity) {
        return "upsell";
    } else if (finalQuantity < initialQuantity) {
        return "downsell";
    } else {
        return "nochange";
    }
}
function determineUpsellOrDownsell(initialPrice, currentPrice) {
    if (!initialPrice || !currentPrice) {
        return "nochange";
    }
    if (currentPrice > initialPrice) {
        return "upsell";
    }
    if (currentPrice < initialPrice) {
        return "downsell";
    }
    return "nochange";
}
// src/components/UploadDialog.tsx
import { trackAttributeSelected } from "@vp/product-options-tracking";
// src/providers/timers/TimerProvider.tsx
import * as React4 from "react";
// src/providers/timers/TimerRegistry.tsx
var TimerRegistry = /*#__PURE__*/ function() {
    "use strict";
    function TimerRegistry() {
        var defaultOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, TimerRegistry);
        this.defaultOptions = defaultOptions;
        this.openTimers = /* @__PURE__ */ new Map();
    }
    _create_class(TimerRegistry, [
        {
            key: "createTimer",
            value: function createTimer(name) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var allOptions = _object_spread({}, this.defaultOptions, options);
                var onEndTimer = allOptions.onEndTimer, onPrematureUnmount = allOptions.onPrematureUnmount, autoStart = allOptions.autoStart;
                var existingTimer = this.openTimers.get(name);
                if (existingTimer) {
                    return existingTimer.timer;
                }
                var timer = {
                    startTimer: function() {
                        _this.startTimer(name, timer, allOptions);
                    },
                    restartTimer: function() {
                        _this.closeTimer(name);
                        _this.startTimer(name, timer, allOptions);
                    },
                    endTimer: function() {
                        var duration = _this.closeTimer(name);
                        if (duration != null) {
                            onEndTimer === null || onEndTimer === void 0 ? void 0 : onEndTimer(name, duration);
                        }
                        return duration;
                    },
                    cancelTimer: function() {
                        _this.closeTimer(name);
                    },
                    unmount: function() {
                        var duration = _this.closeTimer(name);
                        if (duration != null) {
                            onPrematureUnmount === null || onPrematureUnmount === void 0 ? void 0 : onPrematureUnmount(name, duration);
                        }
                    }
                };
                if (autoStart) {
                    timer.startTimer();
                }
                return timer;
            }
        },
        {
            key: "getTimer",
            value: function getTimer(name) {
                var timerDetails = this.openTimers.get(name);
                return timerDetails === null || timerDetails === void 0 ? void 0 : timerDetails.timer;
            }
        },
        {
            key: "startTimer",
            value: function startTimer(name, timer, options) {
                var _this = this;
                var timeoutMs = options.timeoutMs, onTimeout = options.onTimeout;
                var existingTimer = this.openTimers.get(name);
                if (existingTimer) {
                    return;
                }
                var timeoutId;
                if (timeoutMs && onTimeout) {
                    timeoutId = setTimeout(function() {
                        _this.closeTimer(name);
                        onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout(name, timeoutMs);
                    }, timeoutMs);
                }
                var start = performance.now();
                this.openTimers.set(name, {
                    start: start,
                    timeoutId: timeoutId,
                    timer: timer
                });
            }
        },
        {
            key: "closeTimer",
            value: function closeTimer(name) {
                var end = performance.now();
                var details = this.openTimers.get(name);
                if (!details) {
                    return null;
                }
                this.openTimers.delete(name);
                var duration = end - details.start;
                if (details.timeoutId) {
                    clearTimeout(details.timeoutId);
                }
                return duration;
            }
        }
    ]);
    return TimerRegistry;
}();
// src/providers/timers/TimerProvider.tsx
var TimerContext = React4.createContext(new TimerRegistry());
function TimerProvider(props) {
    var children = props.children;
    var registry = new TimerRegistry(props);
    return /* @__PURE__ */ React4.createElement(TimerContext.Provider, {
        value: registry
    }, children);
}
function useNewTimer(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var timerFactory = React4.useContext(TimerContext);
    var timer = React4.useMemo(function() {
        return timerFactory.createTimer(name, options);
    }, []);
    React4.useEffect(function() {
        return function() {
            timer.unmount();
        };
    }, []);
    return timer;
}
// src/components/use-prevent-scroll.tsx
import { useEffect as useEffect3, useState as useState2 } from "react";
function isSafariVersion18() {
    if (typeof window === "undefined") {
        return false;
    }
    var userAgent = navigator.userAgent;
    var vendor = navigator.vendor;
    var isSafari = vendor && vendor.includes("Apple") && userAgent.includes("Safari") && !userAgent.includes("Chrome");
    if (!isSafari) {
        return false;
    }
    var match = userAgent.match(/Version\/(\d+(\.\d+)?)/);
    if (match && match[1]) {
        var version = parseFloat(match[1]);
        return version >= 18 && version < 18.2 && userAgent.includes("iPhone");
    }
    return false;
}
function useIsSafariVersion18() {
    var _useState2 = _sliced_to_array(useState2(false), 2), isSafari18 = _useState2[0], setIsSafari18 = _useState2[1];
    useEffect3(function() {
        setIsSafari18(isSafariVersion18());
    }, []);
    return isSafari18;
}
// src/components/UploadDialog.tsx
var UploadDialog = function(param) {
    var userSelectedOptions = param.userSelectedOptions, locale = param.locale, productName = param.productName, uploadDialogIsOpen = param.uploadDialogIsOpen, onDialogClose = param.onDialogClose, onSubmit = param.onSubmit, quantity = param.quantity, tenant = param.tenant, productKey = param.productKey, productVersion = param.productVersion, siteflowAction = param.siteflowAction, isStudio = param.isStudio, studioDocumentUrl = param.studioDocumentUrl, pricingContextString = param.pricingContextString, loader = param.loader, useFullPath = param.useFullPath, testUserId = param.testUserId, authToken = param.authToken;
    var _data_quantities, _data_quantities_quantities_, _data_quantities1, _data_quantities2;
    var _useContext4 = useContext4(WranglerDataContext), data = _useContext4.data, updating = _useContext4.updating, wranglerContext = _useContext4.context;
    var _useState3 = _sliced_to_array(useState3(quantity !== null && quantity !== void 0 ? quantity : data === null || data === void 0 ? void 0 : (_data_quantities = data.quantities) === null || _data_quantities === void 0 ? void 0 : _data_quantities.selected), 2), selectedQuantity = _useState3[0], setSelectedQuantity = _useState3[1];
    var _useState31 = _sliced_to_array(useState3(void 0), 2), currentPriceInfo = _useState31[0], setCurrentPriceInfo = _useState31[1];
    var _useState32 = _sliced_to_array(useState3(false), 2), showError = _useState32[0], setShowError = _useState32[1];
    var _useState33 = _sliced_to_array(useState3(false), 2), showErrorToast = _useState33[0], setShowErrorToast = _useState33[1];
    var _useState34 = _sliced_to_array(useState3(false), 2), formValid = _useState34[0], setFormValid = _useState34[1];
    var screenClass = useScreenClass();
    var logger = useContext4(LoggingContext);
    var initialLoadTimer = useNewTimer("UploadDialog - initial load", {
        onEndTimer: void 0
    });
    var pricingTimer = useNewTimer("UploadDialog - pricing load/refresh", {
        timeoutMs: 3e3,
        onEndTimer: void 0,
        autoStart: false
    });
    var isSafari18 = useIsSafariVersion18();
    useEffect4(function() {
        if (uploadDialogIsOpen) {
            if (currentPriceInfo) {
                pricingTimer.endTimer();
            } else {
                pricingTimer.startTimer();
            }
        } else {
            pricingTimer.cancelTimer();
        }
    }, [
        uploadDialogIsOpen,
        currentPriceInfo
    ]);
    var updateTimer = useNewTimer("UploadDialog - updating", {
        onEndTimer: void 0
    });
    useEffect4(function() {
        if (updating) {
            updateTimer.restartTimer();
        }
    }, [
        updating
    ]);
    var wranglerSelectedAttributes = (data === null || data === void 0 ? void 0 : data.attributes.reduce(function(result, attr) {
        var selectedOption = attr.options.find(function(option) {
            return option.isSelected;
        });
        if (selectedOption) {
            result[attr.key] = selectedOption.key;
        }
        return result;
    }, {})) || {};
    var initialSelectedOptions = _object_spread({}, userSelectedOptions, wranglerSelectedAttributes);
    var _useState35 = _sliced_to_array(useState3(initialSelectedOptions), 2), selectedOptions = _useState35[0], setSelectedOptions = _useState35[1];
    var initialPrice = data === null || data === void 0 ? void 0 : data.price;
    var minimumQuantity = data === null || data === void 0 ? void 0 : (_data_quantities1 = data.quantities) === null || _data_quantities1 === void 0 ? void 0 : (_data_quantities_quantities_ = _data_quantities1.quantities[0]) === null || _data_quantities_quantities_ === void 0 ? void 0 : _data_quantities_quantities_.quantity;
    var _ref, _ref1;
    var initialQuantity = (_ref1 = (_ref = quantity !== null && quantity !== void 0 ? quantity : data === null || data === void 0 ? void 0 : (_data_quantities2 = data.quantities) === null || _data_quantities2 === void 0 ? void 0 : _data_quantities2.selected) !== null && _ref !== void 0 ? _ref : minimumQuantity) !== null && _ref1 !== void 0 ? _ref1 : 1;
    useEffect4(function() {
        setShowErrorToast(false);
    }, [
        selectedOptions
    ]);
    var ctaButton = useMemo3(function() {
        var initialSelections = userSelectedOptions || {};
        return /* @__PURE__ */ React5.createElement(UploadDialogCta, {
            initialSelections: initialSelections,
            finalSelections: selectedOptions,
            initialPrice: initialPrice,
            finalPriceInfo: currentPriceInfo,
            initialQuantity: initialQuantity,
            finalQuantity: selectedQuantity !== null && selectedQuantity !== void 0 ? selectedQuantity : initialQuantity,
            tenant: tenant,
            locale: locale,
            productKey: productKey,
            productVersion: productVersion,
            productName: productName,
            siteflowAction: siteflowAction,
            isStudio: isStudio,
            studioDocumentUrl: studioDocumentUrl,
            showError: showErrorToast,
            authToken: authToken,
            onSubmitButtonError: function() {
                logger.error("Error on click upload dialog CTA");
                setShowError(true);
                setShowErrorToast(true);
            },
            onSubmitButtonSuccess: function(param) {
                var finalSelections = param.finalSelections, finalQuantity = param.finalQuantity;
                var selectedOptionsInDialog = Object.entries(finalSelections).filter(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (!Object.keys(initialSelections).includes(key)) {
                        return true;
                    }
                    return initialSelections[key] !== value;
                }).reduce(function(accum, param) {
                    var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                    accum[k] = v;
                    return accum;
                }, {});
                var selectedOptionsInDialogWithQuantity = Object.assign({}, selectedOptionsInDialog, {
                    Quantity: "".concat(finalQuantity)
                });
                onSubmit(selectedOptionsInDialogWithQuantity);
            },
            formValid: formValid,
            onToastClose: function() {
                setShowErrorToast(false);
            },
            useFullPath: useFullPath
        });
    }, [
        userSelectedOptions,
        selectedOptions,
        initialPrice,
        currentPriceInfo,
        initialQuantity,
        selectedQuantity,
        tenant,
        locale,
        productKey,
        productVersion,
        productName,
        isStudio,
        studioDocumentUrl,
        showErrorToast,
        formValid
    ]);
    var analytics = useAnalytics();
    var Layout = useMemo3(function() {
        return function(_param) {
            var Buttons = _param.responseButtons, props = _object_without_properties(_param, [
                "responseButtons"
            ]);
            var setSelections = useManagedWranglerSelectionsContext().setSelections;
            return /* @__PURE__ */ React5.createElement(ModalDialog, {
                onlyRenderWhenOpen: true,
                bodyWidth: "capped",
                isOpen: uploadDialogIsOpen,
                takeOver: screenClass === "xs",
                variant: "panel-right",
                onRequestDismiss: function() {
                    onDialogClose();
                    setSelections(initialSelectedOptions);
                    setShowError(false);
                    setShowErrorToast(false);
                },
                standardMode: true
            }, /* @__PURE__ */ React5.createElement(ModalDialogContent, _object_spread({
                "aria-label": productName
            }, isSafari18 ? {
                style: {
                    minHeight: "-webkit-fill-available",
                    maxHeight: "-webkit-fill-available"
                }
            } : {}), /* @__PURE__ */ React5.createElement(ModalDialogNav, null, /* @__PURE__ */ React5.createElement(ModalDialogCloseButton, {
                accessibleText: localizations_default.get("close", locale)
            })), /* @__PURE__ */ React5.createElement(ModalDialogHeader, {
                fontWeight: "normal",
                fontSize: "standard",
                mb: 7
            }, productName && /* @__PURE__ */ React5.createElement(ModalDialogTitle, {
                mb: "3"
            }, productName), /* @__PURE__ */ React5.createElement(Typography, null, localizations_default.get("selectNote", locale))), /* @__PURE__ */ React5.createElement(ModalDialogBody, null, /* @__PURE__ */ React5.createElement(ProductOptions, _object_spread({}, props))), /* @__PURE__ */ React5.createElement(ModalDialogFooter, {
                pinned: true
            }, /* @__PURE__ */ React5.createElement(FooterPrice, null), /* @__PURE__ */ React5.createElement(Buttons, null))));
        };
    }, [
        localizations_default,
        productName,
        locale,
        screenClass,
        uploadDialogIsOpen,
        onDialogClose,
        setSelectedOptions,
        setShowError,
        setShowErrorToast
    ]);
    if (updating || !data) {
        return loader !== null && loader !== void 0 ? loader : /* @__PURE__ */ React5.createElement(React5.Fragment, null);
    }
    if (!(data === null || data === void 0 ? void 0 : data.attributes.length) && !updating) {
        return null;
    }
    initialLoadTimer.endTimer();
    updateTimer.endTimer();
    return /* @__PURE__ */ React5.createElement(ManagedWranglerSelectionsProvider, {
        productKey: productKey,
        productVersion: productVersion,
        merchant: tenant,
        culture: locale,
        selectedAttributes: selectedOptions || {},
        initialSelectedAttributes: userSelectedOptions || {},
        merchandisingExperience: wranglerContext.merchandisingExperience,
        selectedQuantity: data.quantities.selected,
        excludeInitialSelectedAttributes: wranglerContext.excludeInitialSelectedAttributes,
        deselectCompletedOptions: wranglerContext.deselectCompletedOptions,
        testUserId: testUserId,
        requestor: "Upload-Flow-Dialog-Component",
        documentUrl: studioDocumentUrl,
        pricingContextString: pricingContextString,
        includeVat: wranglerContext.includeVat,
        priceStyle: wranglerContext.priceStyle,
        disableDocumentModification: !authToken,
        onChangeQuantity: function(newQuantity) {
            if (newQuantity !== selectedQuantity) {
                trackAttributeSelected({
                    category: "Upload Flow",
                    pageSection: analytics.getPageSection(),
                    pageStage: analytics.getPageStage(),
                    pageName: analytics.getPageName(),
                    label: "Quantity",
                    eventDetail: newQuantity.toString()
                });
            }
            setSelectedQuantity(newQuantity);
        },
        onChangeSelections: function(newSelections) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(newSelections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], newValue = _step_value[1];
                    if (newValue !== selectedOptions[key]) {
                        trackAttributeSelected({
                            category: "Upload Flow",
                            pageSection: analytics.getPageSection(),
                            pageStage: analytics.getPageStage(),
                            pageName: analytics.getPageName(),
                            label: key,
                            eventDetail: newValue
                        });
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setSelectedOptions(newSelections);
        }
    }, /* @__PURE__ */ React5.createElement(ContextAwareConfigurator, {
        priceDisplayMode: "differential-unit",
        allOptionsRequired: true,
        renderingOverrides: {
            responseButtons: function() {
                return ctaButton;
            },
            configuratorLayout: Layout
        },
        onSaveSelections: function() {
            return;
        },
        onCancel: function() {
            return;
        },
        onPriceUpdated: function(newPriceInfo) {
            if (JSON.stringify(currentPriceInfo) !== JSON.stringify(newPriceInfo)) {
                setCurrentPriceInfo(newPriceInfo);
            }
        },
        onValidation: function(param) {
            var isValid = param.isValid;
            setFormValid(isValid);
        },
        showFormErrors: showError,
        loader: /* @__PURE__ */ React5.createElement(React5.Fragment, null)
    }));
};
// src/components/AcceptOption.tsx
import React6, { useEffect as useEffect5, useState as useState4, useContext as useContext5 } from "react";
import { Link as Link2 } from "@vp/swan";
import { useWranglerDataContext as useWranglerDataContext2 } from "@vp/wrangler-data-source";
function AcceptOption(param) {
    var selections = param.selections, title = param.title, tenant = param.tenant, locale = param.locale, productKey = param.productKey, productVersion = param.productVersion, siteflowAction = param.siteflowAction, quantity = param.quantity, studioDocumentUrl = param.studioDocumentUrl, children = param.children, useFullPath = param.useFullPath, onAcceptOptions = param.onAcceptOptions;
    var _wranglerData_data_quantities_quantities_, _wranglerData_data_quantities, _wranglerData_data;
    var _useState4 = _sliced_to_array(useState4(""), 2), nextUrl = _useState4[0], setNextUrl = _useState4[1];
    var wranglerData = useWranglerDataContext2();
    var minimumQuantity = wranglerData === null || wranglerData === void 0 ? void 0 : (_wranglerData_data = wranglerData.data) === null || _wranglerData_data === void 0 ? void 0 : (_wranglerData_data_quantities = _wranglerData_data.quantities) === null || _wranglerData_data_quantities === void 0 ? void 0 : (_wranglerData_data_quantities_quantities_ = _wranglerData_data_quantities.quantities[0]) === null || _wranglerData_data_quantities_quantities_ === void 0 ? void 0 : _wranglerData_data_quantities_quantities_.quantity;
    var logging = useContext5(LoggingContext);
    var _ref;
    var siteflowActionUrl = useSiteflowNextStep(tenant, locale, selections, productKey, productVersion, siteflowAction, (_ref = quantity !== null && quantity !== void 0 ? quantity : minimumQuantity) !== null && _ref !== void 0 ? _ref : 1, logging);
    useEffect5(function() {
        if (siteflowActionUrl) {
            setNextUrl(applyUrlAdjustments(siteflowActionUrl, locale, studioDocumentUrl, useFullPath));
        }
    }, [
        siteflowActionUrl
    ]);
    return /* @__PURE__ */ React6.createElement(Link2, {
        title: title,
        style: {
            color: "inherit",
            textDecoration: "inherit",
            fontWeight: "inherit",
            height: "100%",
            width: "100%"
        },
        target: "_parent",
        onClick: function(e) {
            onAcceptOptions(selections);
            navigate(e, nextUrl);
        },
        href: nextUrl
    }, children);
}
// src/components/UploadFlowComponent.tsx
import { useWranglerDataContext as useWranglerDataContext3 } from "@vp/wrangler-data-source";
import { fireImpression } from "@vp/ab-reader";
// src/components/use-selections.ts
import { useEffect as useEffect6 } from "react";
function useSelections(param) {
    var data = param.data, updating = param.updating, setSelections = param.setSelections, updateTimer = param.updateTimer, context = param.context;
    useEffect6(function() {
        var _context_initialSelectedAttributes;
        var initialSelectedAttributes = (_context_initialSelectedAttributes = context === null || context === void 0 ? void 0 : context.initialSelectedAttributes) !== null && _context_initialSelectedAttributes !== void 0 ? _context_initialSelectedAttributes : {};
        var _context_selectedAttributes;
        var selectedAttributes = (_context_selectedAttributes = context === null || context === void 0 ? void 0 : context.selectedAttributes) !== null && _context_selectedAttributes !== void 0 ? _context_selectedAttributes : {};
        var isSelectionCountMatching = Object.keys(initialSelectedAttributes).length === Object.keys(selectedAttributes).length;
        if (!updating && data && setSelections && isSelectionCountMatching) {
            var containsOptionsToConfigure = false;
            var optionsToSelect = {};
            var _data_attributes;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ((_data_attributes = data === null || data === void 0 ? void 0 : data.attributes) !== null && _data_attributes !== void 0 ? _data_attributes : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var attribute = _step.value;
                    var compatibleOptions = attribute.options.filter(function(option) {
                        return option.isCompatible;
                    });
                    if (compatibleOptions.length === 1 && compatibleOptions[0].isSelected === false) {
                        if (Object.keys(optionsToSelect).length === 0) {
                            optionsToSelect[attribute.key] = compatibleOptions[0].key;
                        } else {
                            containsOptionsToConfigure = true;
                            break;
                        }
                    } else if (compatibleOptions.length > 1) {
                        containsOptionsToConfigure = true;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!containsOptionsToConfigure && Object.keys(optionsToSelect).length > 0) {
                var _data_selections;
                var _data_selections_selectedAttributes;
                setSelections(_object_spread({}, (_data_selections_selectedAttributes = data === null || data === void 0 ? void 0 : (_data_selections = data.selections) === null || _data_selections === void 0 ? void 0 : _data_selections.selectedAttributes) !== null && _data_selections_selectedAttributes !== void 0 ? _data_selections_selectedAttributes : {}, optionsToSelect));
            }
        } else {
            updateTimer.restartTimer();
        }
    }, [
        data,
        updating,
        setSelections,
        updateTimer,
        context
    ]);
}
// src/components/UploadFlowComponent.tsx
function UploadFlowComponent(param) {
    var analyticsPageData = param.analyticsPageData, mpvId = param.mpvId, productName = param.productName, productKey = param.productKey, tenant = param.tenant, locale = param.locale, pricingContextString = param.pricingContextString, quantity = param.quantity, userOptions = param.userOptions, loader = param.loader, productVersion = param.productVersion, siteflowAction = param.siteflowAction, studioDocumentUrl = param.studioDocumentUrl, children = param.children, isStudio = param.isStudio, useFullPath = param.useFullPath, testUserId = param.testUserId, authToken = param.authToken, onPopupOpen = param.onPopupOpen, onSubmit = param.onSubmit, setSelections = param.setSelections, onError = param.onError;
    var _data_context, _data_context1;
    var _useWranglerDataContext3 = useWranglerDataContext3(), data = _useWranglerDataContext3.data, context = _useWranglerDataContext3.context, updating = _useWranglerDataContext3.updating, exceptionMessages = _useWranglerDataContext3.exceptionMessages;
    var _useState5 = _sliced_to_array(useState5(false), 2), isOpen = _useState5[0], setIsOpen = _useState5[1];
    var analyticsManager = useSingleInitialize(function() {
        return new Analytics(analyticsPageData, mpvId);
    });
    var _React7_useState = _sliced_to_array(React7.useState(false), 2), abImpressionFired = _React7_useState[0], setAbImpressionFired = _React7_useState[1];
    var isErrorState = (exceptionMessages === null || exceptionMessages === void 0 ? void 0 : exceptionMessages.length) > 0;
    var initialLoadTimer = useNewTimer("UploadFlowComponent - initial load");
    var updateTimer = useNewTimer("UploadFlowComponent - updating", {
        onEndTimer: void 0
    });
    var onPopupOpenMemo = useMemo4(function() {
        return onPopupOpen !== null && onPopupOpen !== void 0 ? onPopupOpen : function() {
            return;
        };
    }, [
        onPopupOpen
    ]);
    var onSubmitMemo = useMemo4(function() {
        return onSubmit !== null && onSubmit !== void 0 ? onSubmit : function() {
            return;
        };
    }, [
        onSubmit
    ]);
    useEffect7(function() {
        var _data_context, _data_context1;
        if (!abImpressionFired && !updating && (data === null || data === void 0 ? void 0 : (_data_context = data.context) === null || _data_context === void 0 ? void 0 : _data_context.experiment) && (data === null || data === void 0 ? void 0 : (_data_context1 = data.context) === null || _data_context1 === void 0 ? void 0 : _data_context1.variation)) {
            setAbImpressionFired(true);
            fireImpression(data.context.experiment, data.context.variation);
        }
    }, [
        abImpressionFired,
        data === null || data === void 0 ? void 0 : (_data_context = data.context) === null || _data_context === void 0 ? void 0 : _data_context.experiment,
        data === null || data === void 0 ? void 0 : (_data_context1 = data.context) === null || _data_context1 === void 0 ? void 0 : _data_context1.variation
    ]);
    useSelections({
        data: data,
        updating: updating,
        setSelections: setSelections,
        updateTimer: updateTimer,
        context: context
    });
    useEffect7(function() {
        if (isErrorState) {
            onError(exceptionMessages);
        }
    }, [
        exceptionMessages,
        isErrorState,
        onError
    ]);
    if (!data) {
        return /* @__PURE__ */ React7.createElement(React7.Fragment, null, loader !== null && loader !== void 0 ? loader : children);
    }
    initialLoadTimer.endTimer();
    var wranglerSelections = (data === null || data === void 0 ? void 0 : data.attributes.reduce(function(result, attribute) {
        var selectedOption = attribute.options.find(function(option) {
            return option.isSelected;
        });
        if (selectedOption) {
            result[attribute.key] = selectedOption.key;
        }
        return result;
    }, {})) || {};
    var selections = _object_spread({}, userOptions, wranglerSelections);
    function showDialog() {
        analyticsManager.trackDialogDisplayed(userOptions || {});
        setIsOpen(true);
    }
    function closeDialog() {
        setIsOpen(false);
    }
    var defaultControl = /* @__PURE__ */ React7.createElement(Button2, {
        component: "span",
        skin: "primary",
        disabled: updating,
        width: "full-width",
        title: localizations_default.get("upload", locale)
    }, localizations_default.get("upload", locale));
    var childControl = /* @__PURE__ */ React7.createElement(React7.Fragment, null, children);
    if (updating) {
        if (loader) {
            return loader;
        }
        return children ? /* @__PURE__ */ React7.createElement(Spinner, {
            accessibleText: localizations_default.get("loading", locale),
            size: "standard"
        }) : defaultControl;
    }
    updateTimer.endTimer();
    var hasOptionsToConfigure = ((data === null || data === void 0 ? void 0 : data.attributes) || []).length > 0 && ((data === null || data === void 0 ? void 0 : data.attributes) || []).find(function(attribute) {
        return attribute.options.some(function(option) {
            return !option.isSelected && option.isCompatible;
        });
    });
    if (!hasOptionsToConfigure) {
        return /* @__PURE__ */ React7.createElement(AnalyticsProvider, {
            analytics: analyticsManager
        }, /* @__PURE__ */ React7.createElement(AcceptOption, {
            authToken: authToken,
            title: localizations_default.get("upload", locale),
            selections: selections,
            tenant: tenant,
            locale: locale,
            productKey: productKey,
            productVersion: productVersion,
            siteflowAction: siteflowAction !== null && siteflowAction !== void 0 ? siteflowAction : "design",
            quantity: quantity,
            isStudio: isStudio,
            studioDocumentUrl: studioDocumentUrl,
            useFullPath: useFullPath,
            onAcceptOptions: function() {
                var selectedOptionsInDialog = Object.entries(wranglerSelections).filter(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    var initialSelections = userOptions || {};
                    if (!Object.keys(initialSelections).includes(key)) {
                        return true;
                    }
                    return initialSelections[key] !== value;
                }).reduce(function(accum, param) {
                    var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                    accum[k] = v;
                    return accum;
                }, {});
                var selectedOptionsInDialogWithQuantity = Object.assign({}, selectedOptionsInDialog, {
                    Quantity: "".concat(data.selections.quantity)
                });
                onSubmitMemo(selectedOptionsInDialogWithQuantity);
            }
        }, children ? childControl : defaultControl));
    }
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(Button2, {
        skin: "unstyled",
        onClick: function() {
            var selectedOptionsInDialog = Object.entries(wranglerSelections).filter(function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                var initialSelections = userOptions || {};
                if (!Object.keys(initialSelections).includes(key)) {
                    return true;
                }
                return initialSelections[key] !== value;
            }).reduce(function(accum, param) {
                var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                accum[k] = v;
                return accum;
            }, {});
            var selectedOptionsInDialogWithQuantity = Object.assign({}, selectedOptionsInDialog, {
                Quantity: "".concat(data.selections.quantity)
            });
            onPopupOpenMemo(selectedOptionsInDialogWithQuantity);
            showDialog();
        },
        width: "full-width"
    }, children ? childControl : defaultControl), isOpen && /* @__PURE__ */ React7.createElement(UploadDialog, {
        uploadDialogIsOpen: isOpen,
        onDialogClose: closeDialog,
        userSelectedOptions: userOptions,
        locale: locale,
        tenant: tenant,
        productKey: productKey,
        productVersion: productVersion,
        siteflowAction: siteflowAction !== null && siteflowAction !== void 0 ? siteflowAction : "design",
        productName: productName,
        quantity: quantity,
        isStudio: isStudio,
        studioDocumentUrl: studioDocumentUrl,
        pricingContextString: pricingContextString,
        loader: loader,
        useFullPath: useFullPath,
        testUserId: testUserId,
        authToken: authToken,
        onSubmit: function(selectedOptionsInDialog) {
            onSubmitMemo(selectedOptionsInDialog);
        }
    }));
}
// src/components/ErrorLogger.tsx
import React8 from "react";
var ErrorLogger = /*#__PURE__*/ function(_React8_Component) {
    "use strict";
    _inherits(ErrorLogger, _React8_Component);
    function ErrorLogger(props) {
        _class_call_check(this, ErrorLogger);
        var _this;
        _this = _call_super(this, ErrorLogger, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    _create_class(ErrorLogger, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                this.props.logging.error("".concat(this.props.name, " unexpected error: ").concat(error.message), {
                    error: error,
                    context: errorInfo
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props_fallback;
                return this.state.hasError ? (_this_props_fallback = this.props.fallback) !== null && _this_props_fallback !== void 0 ? _this_props_fallback : /* @__PURE__ */ React8.createElement(React8.Fragment, null) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorLogger;
}(React8.Component);
// src/components/UploadFlow.tsx
var EMPTY_SELECTIONS = {};
var DEFAULT_COMPONENT_LOAD_TIMEOUT_MS = 1e4;
function UploadFlow(props) {
    var analyticsPageData = props.analyticsPageData, mpvId = props.mpvId, productKey = props.productKey, tenant = props.tenant, locale = props.locale, quantity = props.quantity, userOptions = props.userOptions, productVersion = props.productVersion, pricingContextString = props.pricingContextString, vatInc = props.vatInc, requestor2 = props.requestor, authToken = props.authToken, onError = props.onError, loader = props.loader, children = props.children, studioDocumentUrl = props.studioDocumentUrl;
    var analyticsManager = useSingleInitialize(function() {
        return new Analytics(analyticsPageData, mpvId);
    });
    var _useState6 = _sliced_to_array(useState6(void 0), 2), testUserId = _useState6[0], setTestUserId = _useState6[1];
    var _useState61 = _sliced_to_array(useState6(userOptions || EMPTY_SELECTIONS), 2), selections = _useState61[0], setSelections = _useState61[1];
    var _useState62 = _sliced_to_array(useState6(false), 2), isReady = _useState62[0], setIsReady = _useState62[1];
    var uploadFlowRequestor = "".concat(LOGGING_REQUESTOR, ": ").concat(requestor2);
    useEffect8(function() {
        ABTests.getTestUserId().then(function(tId) {
            setTestUserId(tId);
            setIsReady(true);
        });
    }, []);
    useEffect8(function() {
        setSelections(userOptions || EMPTY_SELECTIONS);
    }, [
        userOptions
    ]);
    var onErrorCallback = onError !== null && onError !== void 0 ? onError : function() {
        return;
    };
    return /* @__PURE__ */ React9.createElement(LoggingProvider, {
        requestor: uploadFlowRequestor,
        newRelicApplicationId: NEW_RELIC_APPLICATION_ID,
        context: {
            productKey: productKey,
            tenant: tenant,
            locale: locale,
            quantity: quantity,
            userOptions: userOptions,
            productVersion: productVersion,
            selections: selections
        },
        authToken: authToken
    }, /* @__PURE__ */ React9.createElement(LoggingContext.Consumer, null, function(logger) {
        return /* @__PURE__ */ React9.createElement(ErrorLogger, {
            name: "upload-flow-component",
            logging: logger
        }, /* @__PURE__ */ React9.createElement(TimerProvider, {
            autoStart: true,
            timeoutMs: DEFAULT_COMPONENT_LOAD_TIMEOUT_MS,
            onTimeout: function(name, durationMs) {
                return logger.error("Component timer timed out - ".concat(name), {
                    context: {
                        durationMs: durationMs
                    }
                });
            },
            onEndTimer: function(name, durationMs) {
                if (durationMs > 0) {
                    logger.info("Component timer End - ".concat(name), {
                        context: {
                            durationMs: durationMs
                        }
                    });
                }
            },
            onPrematureUnmount: function(name, durationMs) {
                return logger.error("Component timer unmounted before completion - ".concat(name), {
                    context: {
                        durationMs: durationMs
                    }
                });
            }
        }, /* @__PURE__ */ React9.createElement(AnalyticsProvider, {
            analytics: analyticsManager
        }, isReady !== true ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, loader !== null && loader !== void 0 ? loader : children) : /* @__PURE__ */ React9.createElement(WranglerDataProvider, {
            productKey: productKey,
            productVersion: productVersion,
            merchant: tenant,
            culture: locale,
            selectedAttributes: selections || {},
            initialSelectedAttributes: userOptions || {},
            deselectCompletedOptions: true,
            merchandisingExperience: "UploadFlow",
            selectedQuantity: quantity,
            excludeInitialSelectedAttributes: true,
            testUserId: testUserId,
            requestor: requestor2,
            documentUrl: studioDocumentUrl,
            pricingContextString: pricingContextString,
            includeVat: vatInc,
            disableDocumentModification: !authToken,
            priceStyle: "relative"
        }, /* @__PURE__ */ React9.createElement(UploadFlowComponent, _object_spread_props(_object_spread({}, props), {
            testUserId: testUserId,
            onError: onErrorCallback,
            setSelections: setSelections
        }))))));
    }));
}
// src/index.tsx
var index_default = UploadFlow;
export { UploadFlow, index_default as default };
//# sourceMappingURL=index.mjs.map